// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import MatchProvisionStatus from "./match_provision_status_type";
import GameMode from "./game_mode_type";
import Difficulty from "./difficulty_type";
import TacticsBoardPreset from "./tactics_board_preset_type";


export default __t.row({
  matchId: __t.u64().primaryKey().name("match_id"),
  regionId: __t.string().name("region_id"),
  regionUrl: __t.string().name("region_url"),
  get status() {
    return MatchProvisionStatus;
  },
  get mode() {
    return GameMode;
  },
  get difficulty() {
    return Difficulty;
  },
  width: __t.u8(),
  height: __t.u8(),
  minesCount: __t.u16().name("mines_count"),
  playerUserIds: __t.array(__t.u64()).name("player_user_ids"),
  playerUsernames: __t.array(__t.string()).name("player_usernames"),
  hostUserId: __t.u64().name("host_user_id"),
  maxPlayers: __t.u8().name("max_players"),
  isPrivate: __t.bool().name("is_private"),
  matchCode: __t.option(__t.string()).name("match_code"),
  createdAt: __t.u64().name("created_at"),
  startedAt: __t.option(__t.u64()).name("started_at"),
  completedAt: __t.option(__t.u64()).name("completed_at"),
  shieldsPerPlayer: __t.u8().name("shields_per_player"),
  penaltyPerShieldMs: __t.u32().name("penalty_per_shield_ms"),
  finishWindowMs: __t.u32().name("finish_window_ms"),
  finishWindowStrict: __t.bool().name("finish_window_strict"),
  chordingEnabled: __t.bool().name("chording_enabled"),
  spectatorUserIds: __t.array(__t.u64()).name("spectator_user_ids"),
  ttMaxRevealsPerTurn: __t.u8().name("tt_max_reveals_per_turn"),
  ttTimeInitialMs: __t.u64().name("tt_time_initial_ms"),
  ttTimeIncrementMs: __t.u64().name("tt_time_increment_ms"),
  get ttBoardPreset() {
    return __t.option(TacticsBoardPreset).name("tt_board_preset");
  },
  hostOnlyReset: __t.bool().name("host_only_reset"),
  isRankedQueue: __t.bool().name("is_ranked_queue"),
});
